export const isNuxtServer = () => import.meta.server
export const isNuxtClient = () => import.meta.client
